/**
 * Deterministic PRNG utilities for consistent cross-client generation.
 * All visual scenery (asteroids, backgrounds, gas clouds, etc.) must look
 * identical on every client regardless of join time.
 */
/**
 * Mulberry32 — fast, deterministic 32-bit PRNG.
 * Returns a function that produces [0,1) on each call.
 * Same seed = same sequence across all clients.
 */
export function mulberry32(seed) {
    let s = seed | 0;
    return () => {
        s = (s + 0x6D2B79F5) | 0;
        let t = Math.imul(s ^ (s >>> 15), 1 | s);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}
/**
 * Convenience: seeded random in [min, max).
 */
export function seededRange(rng, min, max) {
    return min + rng() * (max - min);
}
//# sourceMappingURL=prng.js.map